import JobApplicationForm from "../../../../components/forms/jobApplicationForm"
const UpdateJobApplication = () => {
    return (
        <div>
            <JobApplicationForm butn="Update" back="/view-application" />
        </div>
    )
} 
export default UpdateJobApplication